import React, { useEffect, useState } from 'react';
import {
    ServiceFilterMain,
    ServiceFilterButton,
    ServiceFilterTitle,
    ServiceFilterDropdown
} from './index.style'
import PropTypes from 'prop-types';
import Item from './item'
import IconPlus from '@svgs/IconPlus';
import IconMinus from '@svgs/IconMinus';

const ServiceFilter = ({items, setCurrentServiceFilter, currentServiceFilter}) => {

    const [active, setActive] = useState(false);

    const handleClick = (filter) => {
        setCurrentServiceFilter(filter);
    }

    useEffect(() => {
        window.addEventListener('mainClicked', (event) => {
            const target = event.detail.targets;
            if (target && target !== document.body) {
                const hasParentWithClass = hasParentWithClassname(target, 'sFDrop');
                if (!hasParentWithClass) {
                    setActive(false)
                }
            }
        })
        function hasParentWithClassname(element, className) {
            let parent = element.parentElement;
            while (parent && !parent.classList.contains(className)) {
              parent = parent.parentElement;
            }
            return parent;
          }
    }, []);

    return (
        <ServiceFilterMain className="sFDrop">
            <ServiceFilterButton onClick={() => setActive(!active)}>
                <ServiceFilterTitle>{(currentServiceFilter.length > 0) ? `Services Filter (${currentServiceFilter.length})` : 'Filter by service'}</ServiceFilterTitle>
                {active ?
                <IconMinus />
                :
                <IconPlus />
                }
            </ServiceFilterButton>
            <ServiceFilterDropdown active={active} >
                {items && items.map((item, index) => (
                    <Item handleClick={handleClick} key={index} currentServiceFilter={currentServiceFilter} item={item}/>
                ))}
            </ServiceFilterDropdown>
        </ServiceFilterMain>
    );
};

ServiceFilter.propTypes = {
    item: PropTypes.object,
    setCurrentFilter: PropTypes.func,
    currentFilter: PropTypes.string,
    title: PropTypes.string,
    filter: PropTypes.string,
};

export default ServiceFilter;